"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConfirmationDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _LoadingButton = _interopRequireDefault(require("./LoadingButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ConfirmationDialog(_ref) {
  let {
    title = 'Confirmation',
    message = 'Are you sure?',
    cancelLabel = 'No',
    confirmLabel = 'Yes',
    onConfirm,
    isWaiting = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    onClose: () => onConfirm(false),
    open: true
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    dividers: true
  }, message), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    autoFocus: true,
    onClick: () => onConfirm(false),
    color: "primary"
  }, cancelLabel), /*#__PURE__*/_react.default.createElement(_LoadingButton.default, {
    onClick: () => onConfirm(true),
    color: "primary",
    loading: isWaiting
  }, confirmLabel)));
}
ConfirmationDialog.defaultProps = {
  title: 'Confirmation',
  message: 'Are you sure?',
  cancelLabel: 'No',
  confirmLabel: 'Yes',
  isWaiting: false
};
ConfirmationDialog.propTypes = {
  title: _propTypes.default.string,
  message: _propTypes.default.string,
  cancelLabel: _propTypes.default.string,
  confirmLabel: _propTypes.default.string,
  onConfirm: _propTypes.default.func.isRequired,
  isWaiting: _propTypes.default.bool
};